var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E5E7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5215 10.5C20.532 10.5 21.3544 11.3222 21.3545 12.333V13.1309H24.3535C25.4449 13.1309 26.3333 14.0186 26.333 15.1094V23.4473C26.333 24.5384 25.4446 25.4268 24.3535 25.4268H11.6455C10.5544 25.4268 9.66699 24.5384 9.66699 23.4473V15.1094C9.66699 14.0186 10.5544 13.1309 11.6455 13.1309H14.6436V12.333C14.6437 11.3222 15.4669 10.5 16.4785 10.5H19.5215ZM10.9854 18.8828V23.4473C10.9854 23.811 11.2818 24.1074 11.6455 24.1074H24.3535C24.7175 24.1074 25.014 23.811 25.0137 23.4473V18.8828H20.085V20.582C20.085 21.1621 19.6136 21.6346 19.0332 21.6348H16.9678C16.3873 21.6348 15.915 21.1622 15.915 20.582V18.8828H10.9854ZM17.2334 20.3154H18.7666V18.8828H17.2334V20.3154ZM11.6455 14.4502C11.2818 14.4502 10.9854 14.746 10.9854 15.1094V17.5635H25.0137V15.1094C25.0137 14.746 24.7175 14.4502 24.3535 14.4502H11.6455ZM16.4785 11.8193C16.1942 11.8193 15.963 12.0496 15.9629 12.333V13.1309H20.0361V12.333C20.0361 12.0497 19.8054 11.8195 19.5225 11.8193H16.4785Z",
    fill: "#8CAEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTitle);
export default __webpack_public_path__ + "static/media/job-title.fa593bec708a70ce1d3bad5bec5eabd5.svg";
export { ForwardRef as ReactComponent };